<div [ngStyle]="contentStyle">
  <div class="component-wrap w-100">
    <div
      #otpInput
      class="field-wrapper d-flex align-items-center justify-content-center"
      [ngStyle]="textContentStyle"
    >
      <label for="code">{{ widgetConfig.inputFieldSettings?.label }}</label>

      <p *ngIf="isTimerSeparated">
        {{ formattedTimer }} &nbsp;
        <span *ngIf="timerTextContent" [innerHTML]="timerTextContent"></span>
      </p>

      <ng-otp-input
        #ngOtpInput
        class="otp-input-field"
        [config]="{
          disableAutoFocus: true,
          length: maxLength,
          inputStyles: currentStyle,
          allowNumbersOnly: true,
        }"
        (onInputChange)="onOtpChange($event)"
      ></ng-otp-input>
    </div>
    <div class="footer otp-footer">
      <div class="resend-wrapper d-flex justify-content-start my-3" [ngStyle]="textContentStyle">
        <button
          [ngStyle]="!buttonGlobalStyles.resendButton.isAllowedGlobalStyling ? resendButtonStyle : {}"
          [innerHTML]="resendTextContent"
          class="resend-btn d-flex"
          [ngClass]="[
            isDisableResendBtn ? 'is-disabled' : '',
            buttonGlobalStyles.resendButton.isAllowedGlobalStyling
              ? buttonGlobalStyles.resendButton.globalStylingClass + ' buttonText'
              : '',
          ]"
          (click)="sendOtp()"
        ></button>
      </div>
      <div>
        <finx-button
          [id]="'verify'"
          (click)="verifyOTP()"
          [labeltext]="buttonContent"
          class="verify-btn pointer-events-none d-flex"
          [buttonStyle]="!buttonGlobalStyles.verifyButton.isAllowedGlobalStyling ? verifyButtonStyle : {}"
          [class]="
            buttonGlobalStyles.verifyButton.isAllowedGlobalStyling
              ? buttonGlobalStyles.verifyButton.globalStylingClass + ' buttonText'
              : 'w-100'
          "
          [style.height]="'100%'"
          [class.mandatory-cta-button]="!buttonGlobalStyles.verifyButton.isAllowedGlobalStyling"
          [isAllowedGlobalStyling]="buttonGlobalStyles.verifyButton.isAllowedGlobalStyling"
          [disabled]="!(code?.length === maxLength) || isVerifying"
          [class.disabled-class]="!(code?.length === maxLength) || isVerifying"
        ></finx-button>
      </div>
    </div>
  </div>
</div>
